import React from "react";
import { string, objectOf, number, oneOfType, shape } from "prop-types";
import { SvgIcons } from "../SvgIcons";

const Icon = ({ className, style, icon }) => {
	if (icon?.svg) return <SvgIcons className={className} style={style} icon={icon.svg} />;

	return <></>;
};

Icon.propTypes = {
	icon: shape({
		svg: shape({
			content: string,
		}),
	}).isRequired,
	className: string,
	style: objectOf(oneOfType([string, number])),
};
Icon.defaultProps = {
	className: "",
	style: {},
};

export default Icon;
export { Icon };
